import { render, staticRenderFns } from "./AdesoesSaidas.vue?vue&type=template&id=138fc3b8"
import script from "./AdesoesSaidas.vue?vue&type=script&lang=js"
export * from "./AdesoesSaidas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports